import { createFileRoute } from '@tanstack/react-router'
import DataPage from '../../Workspace'
import { searchState } from '../../WorkspaceContext'

export const Route = createFileRoute('/data/')({
  validateSearch: search => searchState.parse(search),
  component: DataPage,
})
